import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISaveEvvSettingSetting {
  evv_sync_event: 'manual' | 'daily' | 'realtime'; // daily, realtime, manual
  evv_provider: string;
  evv_data_provider: string;
  timezone: string;
}

const saveEvvSettingSetting = (postData: ISaveEvvSettingSetting) => {
  return http().put(endpoints.companySettings.evvSettings, postData);
};

export function useSaveEvvSettingSetting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveEvvSettingSetting,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchUserDetails'] });
      }
    },
  });
}
